import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { GlobalSelectors } from './global.selectors';
import { AppState } from '@nx-customer-apps/shared/interfaces';

@Injectable({ providedIn: 'root' })
export class GlobalStore {
    private store$ = inject<Store<AppState>>(Store);

    public state$ = this.store$.pipe(select(GlobalSelectors.getGlobalState()));
}
